var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12" } },
    [
      _vm.settings.AskTitle
        ? _c("w-input", {
            attrs: { fancy: "", label: _vm.$ct("title") },
            model: {
              value: _vm.settings.Title,
              callback: function ($$v) {
                _vm.$set(_vm.settings, "Title", $$v)
              },
              expression: "settings.Title",
            },
          })
        : _vm._e(),
      _vm.settings.AskSubTitle1
        ? _c("w-input", {
            attrs: { fancy: "", label: _vm.$ct("sub-title-1") },
            model: {
              value: _vm.settings.SubTitle1,
              callback: function ($$v) {
                _vm.$set(_vm.settings, "SubTitle1", $$v)
              },
              expression: "settings.SubTitle1",
            },
          })
        : _vm._e(),
      _vm.settings.AskSubTitle2
        ? _c("w-input", {
            attrs: { fancy: "", label: _vm.$ct("sub-title-2") },
            model: {
              value: _vm.settings.SubTitle2,
              callback: function ($$v) {
                _vm.$set(_vm.settings, "SubTitle2", $$v)
              },
              expression: "settings.SubTitle2",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }